function contactEmailList_Reducer(state = [], action) {
    switch (action.type) {
        case 'CONTACTS/SET':
            return action.contacts;
        case 'CONTACTS/CLEAR':
            return null;
        default:
            return state;
    }
}

export default contactEmailList_Reducer;



// WEBPACK FOOTER //
// ./src/redux-sagas/reducers/contactEmailList.js